// extracted by mini-css-extract-plugin
module.exports = {"bkw-O":"O_bkw-O__nwRkK"};